import type { ApiService } from '../services/api.service';
import type { Orchestration } from '../models/api.models';

export interface SyncProgress {
  status: Orchestration['status'];
  sources: Orchestration['sources'];
  doneSources: number;
  totalSources: number;
}

/** Dirige o loop /step até terminar, emitindo progresso a cada etapa. */
export async function runSyncOrchestration(
  api: ApiService,
  inicio: string,
  fim: string,
  onProgress: (p: SyncProgress) => void,
  profile: 'financial' | 'historical' = 'financial'
): Promise<Orchestration> {
  const created = await api.createSyncOrchestration(inicio, fim, profile);
  let current = created.orchestration;

  const emit = () =>
    onProgress({
      status: current.status,
      sources: current.sources,
      doneSources: current.sources.filter((s) => s.status === 'done' || s.status === 'failed').length,
      totalSources: current.sources.length
    });

  emit();
  for (let guard = 0; guard < 2000; guard += 1) {
    if (current.status !== 'RUNNING') break;
    const stepped = await api.stepSyncOrchestration(current.id);
    current = stepped.orchestration;
    emit();
  }
  return current;
}
